var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaultmgt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 3.33331H14.9997C6.66634 3.33331 3.33301 6.66665 3.33301 15V25C3.33301 33.3333 6.66634 36.6666 14.9997 36.6666H24.9997C33.333 36.6666 36.6663 33.3333 36.6663 25V21.6666",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7331 5.03333L13.5998 18.1667C13.0998 18.6667 12.5998 19.65 12.4998 20.3667L11.7831 25.3833C11.5165 27.2 12.7998 28.4667 14.6165 28.2167L19.6331 27.5C20.3331 27.4 21.3165 26.9 21.8331 26.4L34.9665 13.2667C37.2331 11 38.2998 8.36666 34.9665 5.03333C31.6331 1.69999 28.9998 2.76666 26.7331 5.03333Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8496 6.91669C25.4023 8.87913 26.4496 10.6668 27.8912 12.1084C29.3328 13.5501 31.1205 14.5974 33.0829 15.15",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultmgt);
export default __webpack_public_path__ + "static/media/vaultmgt.5000082a6bcdf408023debdd7a17f5a8.svg";
export { ForwardRef as ReactComponent };